import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from 'sonner';
import { FullSite } from './components/FullSite';
import { SimpleLanding } from './components/SimpleLanding';
import { AuthCallback } from './components/admin/AuthCallback';
import AdminPage from './pages/AdminPage';
import SpecialPage from './pages/SpecialPage';

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<FullSite />} />
      <Route path="/quick-quote" element={<SimpleLanding />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/special" element={<SpecialPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors offset={96} />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
